import React from "react";
import { Progress } from "antd";
import "./style.css";

interface EvaluationStatusProgressBarProps {
  percentage: Number;
  status: any;
}

const EvaluationStatusProgressBar: React.FC<
  EvaluationStatusProgressBarProps
> = ({ percentage, status }) => {
  const key = status?.key;
  let percentageFilled = percentage.toFixed(2);

  return (
    <div className="">
      <div className="progrress">
        <Progress
          type={"circle"}
          percent={
            key === "open"
              ? parseInt(percentageFilled) - 1
              : parseInt(percentageFilled)
          }
          // style={{width:"10px !important", height:"10px !important"}}
          width={50}
          strokeWidth={6}
          // #00AC4F green
          strokeColor={
            parseInt(percentageFilled) - 1 > 99 ? "#00AC4F" : "#00519D"
          }
          className={`${
            parseInt(percentageFilled) - 1 > 99 ? "green-text" : "blue-text"
          }`}
          format={
            () => `${parseInt(percentageFilled)}%` // show check when 100%
          }
        />
      </div>
    </div>
  );
};

export default EvaluationStatusProgressBar;
